import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useMemo } from "react";
import { ContentBlockerField, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { IRRELEVANT_VISUAL_TYPES } from "./visual-type.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldContentBlockerTemplateIsVisualDarkMode() {
    const { t } = useTranslation();
    const options = useMemo(()=>[
            {
                label: t("Yes"),
                value: true
            },
            {
                label: t("No"),
                value: false
            }
        ], []);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.IsVisualDarkMode,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prev, next)=>prev.isVisual !== next.isVisual || prev.visualType !== next.visualType || prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>(!IRRELEVANT_VISUAL_TYPES.includes(getFieldValue(ContentBlockerField.VisualType)) || !IRRELEVANT_VISUAL_TYPES.includes(getFieldValue(TemplateMetaDataField.Extends)?.[ContentBlockerField.VisualType])) && /*#__PURE__*/ _jsx(Form.Item, {
                    label: getFieldNameTranslated(ContentBlockerField.IsVisualDarkMode, t),
                    extra: t("Define wether dark mode is enabled or not. As soon as no image is found for the content blocker, a default image is automatically used. You can also specify whether the image should be displayed light or dark."),
                    shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
                    required: true,
                    children: ({ getFieldValue })=>{
                        const extended = getFieldValue(TemplateMetaDataField.Extends);
                        const extendedIsVisualDarkMode = extended?.[ContentBlockerField.IsVisualDarkMode];
                        return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                            extendsFieldName: ContentBlockerField.IsVisualDarkMode,
                            disableStrategies: getDisableStrategies(),
                            onKeepContent: extended && /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(Radio.Group, {
                                    value: extendedIsVisualDarkMode,
                                    options: options,
                                    optionType: "button",
                                    buttonStyle: "solid",
                                    disabled: true
                                })
                            }),
                            children: /*#__PURE__*/ _jsx(Form.Item, {
                                name: ContentBlockerField.IsVisualDarkMode,
                                noStyle: true,
                                rules: [
                                    {
                                        required: true,
                                        message: t("Please choose a default dark mode settings.")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Radio.Group, {
                                    options: options,
                                    optionType: "button",
                                    buttonStyle: "solid"
                                })
                            })
                        });
                    }
                })
        })
    });
}
export { FormFieldContentBlockerTemplateIsVisualDarkMode };
